import { enumValues } from 'helpers/common';

import { ResponsiveMediaType } from './enum';

export function isResponsiveMediaType(x: any): x is ResponsiveMediaType {
  return typeof x === 'number' && enumValues(ResponsiveMediaType).includes(x);
}
